import { ReduxState } from './hook-form.redux';

export const getFormValues = <T = {}>(form: string) => (
    state: ReduxState
): T | undefined => state?.hookForm?.[form];
